export const pickKeysLike = <T extends object>(
  source: T,
  key: keyof T,
): Partial<T> => {
  const result: Partial<T> = {};
  for (const k in source) {
    if (k.startsWith(key as string)) {
      result[k] = source[k];
    }
  }
  return result;
};
